const backendUrl = `https://services.cliqueretire.com.br/io/api/v1`;

export default {
  backendUrl
};
